/* AHAN article product cards.
 * Markup in the article body:
 *   <div class="ahan-products">
 *     <div class="ahan-product" data-handle="product-handle"><a href="/products/product-handle">Product name</a></div>
 *   </div>
 * Add data-collection="<collection-handle>" to a marker so a sold-out or deleted product is swapped for that
 * collection's best-selling in-stock product; data-match="<regex>" limits it to products whose title matches. The plain link stays in place for crawlers and if this script fails.
 */
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
  const money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency });
  const fmt = (cents) => money.format(cents / 100);

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function imageUrl(src, width) {
    if (!src) return '';
    const url = src.startsWith('//') ? 'https:' + src : src;
    return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  }

  function render(card, product) {
    const variant = product.variants.find((v) => v.available) || product.variants[0];
    const url = root + 'products/' + product.handle;
    const price = variant.price;
    const compare = variant.compare_at_price && variant.compare_at_price > price ? variant.compare_at_price : null;
    const img = product.featured_image;
    const alt = (product.media && product.media[0] && product.media[0].alt) || product.title;
    const multi = product.variants.length > 1;

    card.innerHTML =
      '<a class="ahan-product__media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + esc(imageUrl(img, 400)) + '" srcset="' + esc(imageUrl(img, 300)) + ' 300w, ' + esc(imageUrl(img, 500)) + ' 500w" sizes="(min-width: 750px) 330px, 45vw" alt="' + esc(alt) + '" loading="lazy" width="400" height="400">' : '') +
      '</a>' +
      (product.vendor ? '<p class="ahan-product__vendor">' + esc(product.vendor) + '</p>' : '') +
      '<a class="ahan-product__title" href="' + url + '">' + esc(product.title) + '</a>' +
      '<p class="ahan-product__price' + (compare ? ' ahan-product__price--sale' : '') + '">' +
        (multi && product.price_varies ? 'From ' : '') + fmt(price) + (compare ? ' <s>' + fmt(compare) + '</s>' : '') +
      '</p>' +
      '<div class="ahan-product__actions">' +
        (!product.available
          ? '<button class="ahan-btn" type="button" disabled>Sold out</button><a class="ahan-btn ahan-btn--outline" href="' + url + '">View product</a>'
          : multi
            ? '<a class="ahan-btn" href="' + url + '">Choose options</a>'
            : '<button class="ahan-btn" type="button" data-ahan-add="' + variant.id + '">Add to cart</button><a class="ahan-btn ahan-btn--outline" href="' + url + '">View product</a>') +
      '</div>';
    card.classList.add('is-ready');
  }

  async function addToCart(button) {
    const id = Number(button.getAttribute('data-ahan-add'));
    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
      const cart = await (await fetch(root + 'cart.js')).json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
        document.body.classList.add('cart-sidebar-show');
        window.halo.updateSidebarCart(cart);
      }
      button.textContent = 'Added ✓';
      setTimeout(() => { button.textContent = label; button.disabled = false; }, 2000);
    } catch (err) {
      button.textContent = 'Try again';
      button.disabled = false;
      console.warn('[ahan-article]', err);
    }
  }

  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  // Storefront returns 429 when too many product requests arrive at once, so retry with backoff.
  async function fetchProduct(handle) {
    for (let attempt = 0; attempt < 4; attempt++) {
      const res = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
      if (res.ok) return res.json();
      if (res.status !== 429) return null;
      await wait(600 * (attempt + 1));
    }
    return null;
  }

  // Sold-out / missing products: swap in the collection's best-selling in-stock product that isn't already on the page.
  // Pools come from sections/ahan-collection-best-sellers.liquid via the Section Rendering API, sorted best-selling.
  const pools = new Map();
  function getPool(collection) {
    if (!pools.has(collection)) {
      const url = root + 'collections/' + encodeURIComponent(collection) + '?sort_by=best-selling&section_id=ahan-collection-best-sellers';
      pools.set(collection, fetch(url)
        .then((res) => (res.ok ? res.text() : ''))
        .then((html) => Array.from(new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.ahan-product[data-card-handle]')))
        .catch(() => []));
    }
    return pools.get(collection);
  }

  function handlesOnPage() {
    const set = new Set();
    document.querySelectorAll('.ahan-article .ahan-product').forEach((el) => {
      const h = el.getAttribute('data-card-handle') || el.getAttribute('data-handle');
      if (h) set.add(h);
    });
    return set;
  }

  let fallbackChain = Promise.resolve();
  function useFallback(card, collection, match) {
    let re = null;
    try { re = match ? new RegExp(match, 'i') : null; } catch (e) { re = null; }
    const fits = (el) => !re || re.test((el.querySelector('.ahan-product__title') || el).textContent);
    // Run one at a time so two sold-out cards never pick the same replacement.
    fallbackChain = fallbackChain.then(async () => {
      const pool = await getPool(collection);
      const shown = handlesOnPage();
      const pick = pool.find((el) => fits(el) && !shown.has(el.getAttribute('data-card-handle')));
      if (pick && card.isConnected) card.replaceWith(pick.cloneNode(true));
    }).catch(() => {});
    return fallbackChain;
  }

  async function hydrate(cards) {
    const queue = Array.from(cards);
    const worker = async () => {
      while (queue.length) {
        const card = queue.shift();
        const collection = card.getAttribute('data-collection');
        try {
          const product = await fetchProduct(card.getAttribute('data-handle'));
          if (product && (product.available || !collection)) render(card, product);
          else if (collection) await useFallback(card, collection, card.getAttribute('data-match'));
          // otherwise keep the plain fallback link
        } catch (e) { /* keep fallback */ }
      }
    };
    await Promise.all([worker(), worker(), worker()]);
  }

  function init() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.ahan-article [data-ahan-add]');
      if (btn) { e.preventDefault(); addToCart(btn); }
    });

    document.querySelectorAll('.ahan-article .ahan-product[data-fallback-collection]').forEach((card) => {
      useFallback(card, card.getAttribute('data-fallback-collection'), card.getAttribute('data-fallback-match'));
    });

    const cards = document.querySelectorAll('.ahan-article .ahan-product[data-handle]');
    if (!cards.length) return;
    // Fallback for markers the theme could not render server-side. Only fetch once the cards are near the viewport.
    if ('IntersectionObserver' in window) {
      const pending = new Set(cards);
      const io = new IntersectionObserver((entries) => {
        const visible = entries.filter((e) => e.isIntersecting).map((e) => e.target);
        visible.forEach((el) => { io.unobserve(el); pending.delete(el); });
        if (visible.length) hydrate(visible);
      }, { rootMargin: '600px 0px' });
      pending.forEach((el) => io.observe(el));
    } else {
      hydrate(cards);
    }

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
